import React from "react";
import "../../sass/ui/switch.scss";

export const SwitchButton = ({ checked, onChange, ...rest }) => {
  return (
    <label className="switch">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...rest}
      />
      <span className="slider" />
    </label>
  );
};
